export * from './ValueInTable';
